import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import * as styles from './styles.css';

import { trackBrochureClick } from './tracking';
import { NEWBUILDING_BROCHURE_KEY } from '../../constants/brochure';
import { getBrochure, getName } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/withApplicationContext';

export function NewbuildingBrochureContainer() {
  const newbuildingName = useSelector(getName);
  const url = useSelector(getBrochure);
  const { config } = useApplicationContext();
  const isNewbuildingBrochureEnabled = config.get<boolean>(NEWBUILDING_BROCHURE_KEY);

  if (!isNewbuildingBrochureEnabled) {
    return null;
  }

  if (newbuildingName === '' || url === '' || url === null) {
    return null;
  }

  return (
    <a
      data-testId="newbuilding-brochure"
      className={styles['link']}
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={() => {
        trackBrochureClick();
      }}
    >
      <UIText1
        display="block"
        whiteSpace="nowrap"
        color="text-main-default"
      >{`Брошюра ЖК «${newbuildingName}»`}</UIText1>
      <div className={styles['icon']}></div>
    </a>
  );
}
